import NotificationsAction from '@bv/layouts/main/storybook/actions-examples/NotificationsAction.vue';
import { RouteRecordRaw } from '@bv/router';

import BillingWallet from '@/components/Main/topbar/BillingWallet.vue';
import OldBillingWallet from '@/components/Main/topbar/OldBillingWallet.vue';
import { billingRoutes } from '@/router/main/routes/billing.routes';
import { dashboardRoutes } from '@/router/main/routes/dashboard.routes';
import { integrationsRoutes } from '@/router/main/routes/integrations';
import { sallaCallbackRoute } from '@/router/main/routes/integrations/salla.routes';
import { profileRoutes } from '@/router/main/routes/profile.routes';

export { modules } from '@/router/main/modules';

export const mainRoutes: RouteRecordRaw = {
  path: '/',
  name: 'main',
  redirect: { name: 'dashboard' },
  meta: {
    prependHeaderActions: OldBillingWallet,
    headerActions: [
      {
        type: 'notifications',
        component: NotificationsAction,
      },
      {
        type: 'append',
        component: BillingWallet,
      },
    ],
  },
  children: [dashboardRoutes, profileRoutes, ...billingRoutes, integrationsRoutes, sallaCallbackRoute],
};
